import * as models from "./api/models";
import formatDateString from "../lib/formatDateString";

export const DEFAULT_URL_CODE = "CpgfJz";
const ANNUAL_OBLIGATIONS_MULTIPLIER = 12;

function formatCurrency(moneyInputString: string): number {
    const stripped = moneyInputString.replace(/[^0-9.]+/g, "");
    const dotIndex = stripped.indexOf(".");
    const withCents = dotIndex === -1 ? `${stripped}.00` : stripped;
    return parseFloat(withCents);
}

function getCardFields(
    defaultCardBrand: "VISA" | "MC",
    cardSelection?: string | null,
): {cardType: string; cardImage: string | null} {
    if (!cardSelection) {
        return {
            cardType:
                defaultCardBrand === "VISA"
                    ? models.CardSelectionOptions.GoldVisa
                    : models.CardSelectionOptions.GoldMC,
            cardImage: null,
        };
    }
    if (
        cardSelection === models.CardSelectionOptions.GoldVisa ||
        cardSelection === models.CardSelectionOptions.Platinum ||
        cardSelection === models.CardSelectionOptions.BlackVisa ||
        cardSelection === models.CardSelectionOptions.TealVisa ||
        cardSelection === models.CardSelectionOptions.BlueVisa ||
        cardSelection === models.CardSelectionOptions.GoldMC ||
        cardSelection === models.CardSelectionOptions.BlackMC ||
        cardSelection === models.CardSelectionOptions.TealMC ||
        cardSelection === models.CardSelectionOptions.BlueMC
    ) {
        return {cardType: cardSelection, cardImage: null};
    }
    return {
        cardType:
            defaultCardBrand === "VISA"
                ? models.CardSelectionOptions.PhotocardVisa
                : models.CardSelectionOptions.PhotocardMC,
        cardImage: cardSelection,
    };
}

export default function applicationToApplicationValidate(
    app: models.Application,
    isInvite: boolean,
    defaultCardBrand: "VISA" | "MC",
): models.ApplicationValidate {
    const dob = formatDateString(app[models.AppKeys.DateOfBirth]);
    let urlCode = null;
    if (!isInvite) {
        urlCode = app[models.AppKeys.UrlCode] ? app[models.AppKeys.UrlCode] : DEFAULT_URL_CODE;
    }
    const {cardType, cardImage} = getCardFields(
        defaultCardBrand,
        app[models.AppKeys.CardSelection],
    );
    return {
        [models.AppKeys.AccountTotal]: formatCurrency(app[models.AppKeys.AccountTotal]),
        [models.AppKeys.Address]: app[models.AppKeys.Address],
        [models.AppKeys.AnnualGrossIncome]: formatCurrency(app[models.AppKeys.AnnualGrossIncome]),
        [models.AppKeys.CheckingAccount]: !!app[models.AppKeys.CheckingAccount],
        [models.AppKeys.DateOfBirth]: dob,
        [models.AppKeys.Email]: app[models.AppKeys.Email],
        [models.AppKeys.FirstName]: app[models.AppKeys.FirstName],
        [models.AppKeys.LastName]: app[models.AppKeys.LastName],
        [models.AppKeys.MiddleInitial]: app[models.AppKeys.MiddleInitial]
            ? app[models.AppKeys.MiddleInitial]
            : undefined,
        [models.AppKeys.AnnualObligation]: app[models.AppKeys.AnnualObligation]
            ? formatCurrency(app[models.AppKeys.AnnualObligation]) * ANNUAL_OBLIGATIONS_MULTIPLIER
            : null,
        [models.AppKeys.PaymentAccount]: [app[models.AppKeys.PaymentAccount]],
        [models.AppKeys.Residency]: !!app[models.AppKeys.Residency],
        [models.AppKeys.SavingsAccount]: !!app[models.AppKeys.SavingsAccount],
        [models.AppKeys.SocialSecurity]: app[models.AppKeys.SocialSecurity],
        [models.AppKeys.College]: app[models.AppKeys.College],
        [models.AppKeys.StudentStatus]: app[models.AppKeys.StudentStatus],
        [models.AppKeys.CardSelection]: cardType,
        [models.cardImageKey]: cardImage,
        homePhone: app[models.AppKeys.PrimaryPhone],
        [models.AppKeys.UrlCode]: urlCode,
        [models.AppKeys.InviteCode]: app[models.AppKeys.InviteCode],
        [models.AppKeys.ReferralCode]: app[models.AppKeys.ReferralCode],
    };
}
